'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $("#advancedSearchMain", this).each(function () {
        $(this).find("button[type=submit]").each(function () {
            $(this).attr("data-filter", "true");
            $(this).attr("data-query-target", "#mainContent");
            $(this).click(function () {
                var obj = $('#AdvancedSearchForm').serializeObject();
                if (obj.ReleaseFrom) {
                    var releaseFrom = $("#ReleaseFrom").data("DateTimePicker").date();
                    if (releaseFrom) obj.ReleaseFrom = releaseFrom.format("YYYY-MM-DD");else obj.ReleaseFrom = "";
                }
                if (obj.ReleaseTo) {
                    var releaseTo = $("#ReleaseTo").data("DateTimePicker").date();
                    if (releaseTo) obj.ReleaseTo = releaseTo.format("YYYY-MM-DD");else obj.ReleaseTo = "";
                }
                if (obj.ProductTypesIds) {
                    obj.ProductTypesIds = createArrayIfSingle(obj.ProductTypesIds);
                }
                if (obj.PublishersIds) {
                    obj.PublishersIds = createArrayIfSingle(obj.PublishersIds);
                }
                if (obj.EditionsIds) {
                    obj.EditionsIds = createArrayIfSingle(obj.EditionsIds);
                }
                if (obj.LanguagesIds) {
                    obj.LanguagesIds = createArrayIfSingle(obj.LanguagesIds);
                }
                if (obj.CategoriesIds) {
                    obj.CategoriesIds = createArrayIfSingle(obj.CategoriesIds);
                }
                (0, _autoQueryHelper.updateQuery)($(this), obj);
            });
        });
    });

    registerPagerCustom();
};

var _autoQueryHelper = require('linksoft/utils/auto-query-helper');

var $ = require("jquery");

$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

function createArrayIfSingle(obj) {
    if (!obj) return obj;
    if (Object.prototype.toString.call(obj) === '[object Array]') {
        return obj;
    } else {
        return [obj];
    }
}

function registerPagerCustom() {
    window.addEventListener('popstate', function (event) {
        var url = event.target.document.URL;
        window.location = url;
    });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/advancedSearch.js
// module id = 1052
// module chunks = 1